import React from 'react'
import { ENCOUNTER_TYPES } from '../../../sharedConstants'

export default function PanelEncTypeButtons({ setEncType, encType, disabled }) {
  return (
    <div className={'d-flex gap-2 align-items-center PanelEncTypeButtons'}>
      <div>Encounter Type:</div>
      <select
        value={encType || ENCOUNTER_TYPES.INITIAL}
        onChange={(e) => setEncType(e.target.value)}
        disabled={disabled}
      >
        {Object.values(ENCOUNTER_TYPES).map((enc) => {
          return (
            <option key={enc} value={enc}>
              {enc}
            </option>
          )
        })}
      </select>
    </div>
  )
}
